import React from 'react'

import TabsGenerator from '@f/components/TabsGenerator'

const ResultsPage = props => {
  const {
    apiSuccess,
    allCategories,
    search,
    resultsPageCategory,
    country,
    tabContent,
    popularResults
  } = props
  return (
    <>
      {apiSuccess && (
        <div className='[ f-wrap f-m-v-040 f-p-t-060 ]'>
          <div className='[ f-t-tminor f-c-fo-pri ]'>
            {allCategories.results.length === 1
              ? `${allCategories.results.length} Ergebnis gefunden`
              : `${allCategories.results.length} Ergebnisse gefunden`}
          </div>
          {!allCategories.results.length && (
            <div className='[ f-t-body f-m-t-010 f-c-fo-pri ]'>
              {`Leider haben wir für den Begriff '${search}' keine Ergebisse gefunden. Bitte versuchen Sie einen anderen Begriff.`}
            </div>
          )}
        </div>
      )}
      <div>
        {!allCategories.results.length ? (
          <div className='[ f-c-ba-whi f-m-v-040 f-p-t-060 ]'>
            <div className='[ f-wrap f-t-tsection f-c-fo-pri ]'>
              Beliebte Suchergebnisse
            </div>
            {resultsPageCategory(popularResults, search, country)}
          </div>
        ) : (
          <TabsGenerator tabContent={tabContent} />
        )}
      </div>
    </>
  )
}

export default ResultsPage
